<template>
    <SignUpForm />
</template>

<script>
import SignUpForm from "@/components/SignUpForm.vue";

export default {
    name: 'SignUpView',
    components: {
        SignUpForm
    }
}
</script>